import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { verifyEmail, verifyAdminEmail, emailVerificationReset } from '../../redux/actions/emailVerificationActions';
import { AlmataMainLogo } from '../../../assets/image';
import './EmailVerification.css';

const EmailVerification = () => {
  const { token: pathToken, email: pathEmail } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { loading, success, error, message } = useSelector(state => state.emailVerification);
  console.log("emailVerification state:", { loading, success, error, message });
  const [countdown, setCountdown] = useState(0);

  // Get token and email from query params or path params
  const getTokenAndEmail = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryToken = searchParams.get('token');
    const queryEmail = searchParams.get('email');
    
    return {
      token: queryToken || pathToken,
      email: queryEmail || pathEmail
    };
  };

  const { token, email } = getTokenAndEmail();
  const isAdminRoute = location.pathname === '/admin/verify';



  useEffect(() => {
    if (token && email) {
      if (isAdminRoute) {
        dispatch(verifyAdminEmail(token, email));
      } else {
        dispatch(verifyEmail(token, email));
      }
    }
    return () => {
      dispatch(emailVerificationReset());
    };
  }, [dispatch, token, email, isAdminRoute]);

  useEffect(() => {
    if (success) {
      setCountdown(3);
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate('/login');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [success, navigate]);



  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src={AlmataMainLogo}
            alt="Cyber Risk Report Logo"
            style={{ height: "auto", width: "100px", marginTop: "10px" }}
            loading="lazy"
            className="mb-3"
          />
          <h1 className="login-title">Email Verification</h1>
        </div>

        <div className="text-center">
          {loading && (
            <div>
              <div className="spinner-border_email_verification text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Verifying your email...</p>
            </div>
          )}

          {success && (
            <>
              <div className="alert alert-success d-flex align-items-center justify-content-center">
                <p className="mb-0">{message}</p>
              </div>
              <div className="alert alert-success d-flex align-items-center justify-content-center">
                <p className="mb-0">Redirecting to login in {countdown}s...</p>
              </div>
            </>
          )}

          {error && (
            <div className="alert d-flex align-items-center justify-content-center alert-danger">
              <p className="mb-0">{error}</p>
            </div>
          )}

          {(success || error) && (
            <button
              className="login-btn w-100 mt-3"
              onClick={handleBackToLogin}
            >
              Back to Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;